import React, { Component } from 'react'
import Loadable from 'react-loadable'
import Loading from './Loading'
import PropTypes from 'prop-types'


const env = process.env.REACT_APP_ORGANIZATION_NAME

require('../styles/GridSplash.css')


const Hero = Loadable({
  loader: () =>
    import ('./Splash/Hero'),
  loading: Loading
})
const API = Loadable({
  loader: () =>
    import ('./Splash/API'),
  loading: Loading
})
const Model = Loadable({
  loader: () =>
    import ('./Splash/Model'),
  loading: Loading
})
const InfoGraphic = Loadable({
  loader: () =>
    import ('./Splash/InfoGraphic'),
  loading: Loading
})
const Geospatial = Loadable({
  loader: () =>
    import ('./Splash/Geospatial'),
  loading: Loading
})
const Clients = Loadable({
  loader: () =>
    import ('./Splash/Clients'),
  loading: Loading
})

class Splash extends Component {

  addSimpleFilterToQueryString(filterName, filterValue) {
    let params = new URLSearchParams(this.props.location.search)

    const filter = `${filterName}=${filterValue}`
    params.append('filter', filter)
    return params.toString()
  }

  addParamsToQueryString() {
    let params = new URLSearchParams(this.props.location.search)

    params.append('filter','browseType=Map Service')
    params.append('filter','browseType=Map')
    params.append('conjunction','browseType=OR')
    return params.toString()
  }

  render() {

    if (env==='sagedat') {
      return <div>
        {/* <div className="warning">
        This demo only works in browsers that support CSS Grid Layout. If you can see this message, then your browser isn't supporting Grid.
        You can try out Grid in <a href="https://nightly.mozilla.org/">Firefox Nightly</a> or <a href="http://gridbyexample.com/browsers/">other browsers by flipping a flag</a>.
        It's likely that you will see bugs if you are not in the most recent version of Nightly. It depends on parts of Grid that were only finished, are are only working in Firefox Nightly.
      </div> */}
        <Hero />
        <Model />
        <API />
      </div>

    } else {

      return <div>
        {/* <div className="warning">
        This demo only works in browsers that support CSS Grid Layout. If you can see this message, then your browser isn't supporting Grid.
        You can try out Grid in <a href="https://nightly.mozilla.org/">Firefox Nightly</a> or <a href="http://gridbyexample.com/browsers/">other browsers by flipping a flag</a>.
        It's likely that you will see bugs if you are not in the most recent version of Nightly. It depends on parts of Grid that were only finished, are are only working in Firefox Nightly.
      </div> */}
        <Hero />
        <Model />
        {/* <API />
        <InfoGraphic />
        <Geospatial />
        <Clients /> */}
      </div>
    }

  }
}

export default Splash


Splash.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.any
  })
}
